export default __webpack_public_path__ + "static/char-v-62-zh-Hant-252955040b5d41006363d14bd67ae7e6.mp4";